export default __webpack_public_path__ + "media/images/svg/email-icon-a13ae3efa1fdfa8e27cba2e1052dada4.svg";